import React from 'react';
import Section from '../components/common/Section';
import { Helmet } from 'react-helmet-async';

const ShippingPolicy = () => {
    return (
        <>
            <Helmet>
                <title>Shipping Policy | PyrusMedia</title>
                <meta name="description" content="Shipping Policy for PyrusMedia" />
            </Helmet>
            <Section className="bg-black pt-32 pb-20">
                <div className="max-w-4xl mx-auto text-gray-300">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Shipping Policy</h1>

                    <div className="space-y-8">
                        <section>
                            <p className="leading-relaxed mb-4">
                                For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only.
                            </p>
                            <p className="leading-relaxed mb-4">
                                Orders are shipped within 1-2 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms.
                            </p>
                            <p className="leading-relaxed mb-4">
                                Pyrus Media is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 1-2 days rom the date of the order and payment or as per the delivery date agreed at the time of order confirmation.
                            </p>
                            <p className="leading-relaxed mb-4">
                                Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration.
                            </p>
                            <p className="leading-relaxed">
                                For any issues in utilizing our services you may contact our helpdesk on 7720830178 or <a href="mailto:info@pyrusmedia.in" className="text-[#bebd19] hover:underline">info@pyrusmedia.in</a>.
                            </p>
                        </section>
                    </div>
                </div>
            </Section>
        </>
    );
};

export default ShippingPolicy;
